var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "print-correspondence-page"
  }, [_c("div", {
    staticClass: "btn-wrap"
  }, [_c("el-button", {
    directives: [{
      name: "print",
      rawName: "v-print",
      value: _vm.printObj,
      expression: "printObj"
    }],
    attrs: {
      type: "primary",
      size: "mini"
    }
  }, [_vm._v("打印")])], 1), _vm.src ? _c("img", {
    attrs: {
      src: _vm.src
    }
  }) : _vm._e(), _c("div", {
    staticClass: "wrap",
    attrs: {
      id: "print-correspondence"
    }
  }, _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      staticClass: "list-wrap"
    }, [_c("div", {
      staticClass: "editor-wrap custom-ck-editor-style isDocument"
    }, [_c("div", {
      staticClass: "content-warp"
    }, [_c("img", {
      staticClass: "barcode",
      attrs: {
        src: item.code
      }
    }), _c("div", {
      ref: "docContent".concat(index),
      refInFor: true,
      class: "docContent".concat(index, " docContent"),
      attrs: {
        id: "docContent".concat(index)
      }
    }), !item.c02SendFile1 ? _c("div", {
      staticClass: "ck-blurred ck ck-content ck-editor__editable ck-rounded-corners ck-editor__editable_inline ck-read-only",
      attrs: {
        lang: "en",
        dir: "ltr",
        role: "textbox",
        contenteditable: "false"
      },
      domProps: {
        innerHTML: _vm._s(item.html)
      }
    }) : _c("div", [_c("span", {
      staticStyle: {
        display: "none"
      }
    }, [_vm._v(_vm._s(_vm.getFileContent(item, item.c02SendFile1, index)))])])])])]);
  }), 0), _c("div", {
    ref: "dom"
  })]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };